// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"b1b69278","513":"a564d648","703":"d5b0604c","787":"ec81ae8c"}[chunkId] + ".chunk.js";
};